import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578391e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FormFieldMultiSelect = _resolveComponent("FormFieldMultiSelect")!
  const _component_NorthIcon = _resolveComponent("NorthIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SouthIcon = _resolveComponent("SouthIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_BaseTable = _resolveComponent("BaseTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.filters,
        loading: false,
        enumerable: true
      }, {
        "cell(label)": _withCtx(({ row, rowIndex }) => [
          _createVNode(_component_FormField, {
            value: row.label,
            "onUpdate:value": ($event: any) => ((row.label) = $event),
            clearable: true,
            name: `[${rowIndex}][label]`,
            class: "margin-0"
          }, null, 8, ["value", "onUpdate:value", "name"])
        ]),
        "cell(fields)": _withCtx(({ row, rowIndex }) => [
          _createVNode(_component_FormFieldMultiSelect, {
            "selected-options": row.fields,
            "onUpdate:selected-options": ($event: any) => ((row.fields) = $event),
            clearable: true,
            name: `[${rowIndex}][fields]`,
            options: _ctx.fieldOptionList,
            class: "margin-0"
          }, null, 8, ["selected-options", "onUpdate:selected-options", "name", "options"])
        ]),
        "cell(description)": _withCtx(({ row, rowIndex }) => [
          _createVNode(_component_FormField, {
            value: row.description,
            "onUpdate:value": ($event: any) => ((row.description) = $event),
            name: `[${rowIndex}][description]`,
            class: "margin-0",
            type: "textarea"
          }, null, 8, ["value", "onUpdate:value", "name"])
        ]),
        "cell(coefficient)": _withCtx(({ row, rowIndex }) => [
          _createVNode(_component_FormField, {
            value: row.coefficient,
            "onUpdate:value": ($event: any) => ((row.coefficient) = $event),
            type: "number",
            name: `[${rowIndex}][coefficient]`,
            class: "margin-0"
          }, null, 8, ["value", "onUpdate:value", "name"])
        ]),
        "cell(actions)": _withCtx(({ rowIndex }) => [
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Move up",
            disabled: rowIndex === 0,
            onClick: ($event: any) => (_ctx.handleClick(_ctx.filters, rowIndex, 'up'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NorthIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Move down",
            disabled: rowIndex === _ctx.filters.length - 1,
            onClick: ($event: any) => (_ctx.handleClick(_ctx.filters, rowIndex, 'down'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SouthIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Delete",
            onClick: ($event: any) => (_ctx.removeField(rowIndex))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DeleteIcon)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data"]),
      _createElementVNode("div", null, [
        _createVNode(_component_BaseButton, {
          variant: "outline-primary",
          title: "Add option",
          onClick: _ctx.addElement
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}